export enum CreatePdfSteps {
  Configuration,
  Settings,
}

export const showLastModified = new Set([CreatePdfSteps.Configuration]);
